export const vendorTags = ['Vendors', 'Payments', 'Advance'];
